'use client';
import { useFormState } from 'react-dom';

import { RegisterButton } from './register-button.component';
import { TextInput } from '@prickle/next-ui';
import { registerWithCredentials } from '../actions/register-with-credentials.action';
import { ErrorMessage } from '@tuning-bytes/users/ui';
import { UserMarketingAgreement } from '@tuning-bytes/ui';
import { NewsletterModal } from './newsletter.modal';
import { useUiStore } from '@tuning-bytes/data-access';
import { startTransition, useRef } from 'react';
import { useForm } from '@prickle/form/formik';
import { signUpValidationSchema } from '@tuning-bytes/users/util-form-schema-validators';
import { useTranslations } from 'next-intl';

export const CredentialsForm = () => {
  const t = useTranslations('SignUpPage.form');
  const [errorMessage, dispatch] = useFormState(
    registerWithCredentials,
    undefined,
  );

  const formRef = useRef<HTMLFormElement>(null);

  const onSubmit = () => {
    if (formRef.current === null) return;

    const formData = new FormData(formRef.current);

    const newsLetter =
      document
        .querySelector('input[name="newsletter"]')
        ?.getAttribute('aria-checked') || 'false';

    if (
      document
        .querySelector('input[name="newsletter"]')
        ?.getAttribute('aria-checked') === 'true' ||
      sessionStorage.getItem('newsletter-popup') === 'true'
    ) {
      startTransition(async () => {
        formData.append('newsletter', newsLetter);
        dispatch(formData);
      });
    } else {
      useUiStore.getState().setIsDisplaySuccesModal(true);
    }
  };

  const { errorMessages, handleChange, handleSubmit, isValid } = useForm({
    initialValues: {
      email: '',
      password: '',
      passwordConfirm: '',
      newsletter: false,
    },
    validationSchema: signUpValidationSchema,
    onSubmit,
  });

  return (
    <form
      action={dispatch}
      className="space-y-4"
      onSubmit={handleSubmit}
      ref={formRef}
    >
      <div className="space-y-2">
        <TextInput
          name="email"
          placeholder="example@acme.com"
          bordered
          label={{
            text: t('email'),
            position: 'top',
            required: true,
          }}
          onChange={handleChange}
          error={errorMessages.email}
        />
      </div>
      <div className="space-y-2">
        <TextInput
          name="password"
          type="password"
          bordered
          label={{
            text: t('password'),
            position: 'top',
            required: true,
          }}
          onChange={handleChange}
          error={errorMessages.password}
        />
      </div>

      <div className="space-y-2">
        <TextInput
          name="passwordConfirm"
          type="password"
          bordered
          label={{
            text: t('confirmPassword'),
            position: 'top',
            required: true,
          }}
          onChange={handleChange}
          error={errorMessages.passwordConfirm}
        />
      </div>

      <UserMarketingAgreement />

      <RegisterButton isValid={isValid} />
      <ErrorMessage errorMessage={errorMessage} />
      <NewsletterModal dispatch={dispatch} />
    </form>
  );
};
